import { Component } from '@angular/core';

@Component({
  selector: 'tun-arrow-down-icon',
  templateUrl: './arrow-down-icon.component.html'
})
export class ArrowDownIconComponent {
}
